var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    viewBox: "0 0 68 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 40L32 7.45459L2 40L7.5 62H56.5455L62 40Z",
    fill: "#91C688",
    stroke: "#56A748",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45459 48.3637L32 7.45459L56.5455 48.3637V62H7.45459V48.3637Z",
    fill: "#DDEDDA",
    stroke: "#56A748",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8181 44.1816C23.8181 41.9725 25.609 40.1816 27.8181 40.1816H36.1818C38.3909 40.1816 40.1817 41.9725 40.1817 44.1816V61.9998H23.8181V44.1816Z",
    fill: "white",
    stroke: "#56A748",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62V2",
    stroke: "#56A748",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 41,
    r: 11,
    fill: "#FEEFD7",
    stroke: "#976821",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.343 41L61.6569 41",
    stroke: "#976821",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46.657L56 35.3431",
    stroke: "#976821",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampPlus);
export default __webpack_public_path__ + "static/media/camp--plus.c9fcbfae.svg";
export { ForwardRef as ReactComponent };